<template>
<v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงานภาพงานซ่อม</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>
<template>
                <v-container>
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                        <v-form ref="frmReport" lazy-validation>
                        <v-row>
                            <v-col>
                                <v-text-field outlined placeholder=" "
                                    :rules="[rules.required]" 
                                    label="เลขที่ใบสั่งซ่อม" v-model="jobNo"></v-text-field></v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn  class="ma-2" color="primary" small target="_blank" @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                            
                        </v-row>
                        </v-form>
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

            <template  width="1000px">
            <v-data-table 
                
                :headers="headers"
                :items="items"
                class="pt-5"
                >
            </v-data-table>
         </template>
        </v-card>
</v-container>
</template>

<script>
import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import {listJobImage, exportJobImage} from '@/api/reports/report-api.js'
import rules from '@/assets/js/rules.js'
export default {
    name: 'JobImageReport',
    components: {
        UserBranchDropdown
    },
    props:["pageCode"],
    data: () => ({
        rules: rules,
        jobNo: '',
        headers: [
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
            {text: "วันที่ใบสั่งซ่อม", value: "jobDate"},
            {text: "วันที่ Upload รูปภาพ", value: "uploadDate"},
            {text: "ขั้นตอนงานซ่อม", value: "serviceName"},
            {text: "จำนวนรูปภาพ", value: "imageCount"},
         ],
         items: [],
         branchCode: ''
    }),
    methods: {
        setCurrentBranch(branchCode) {
            this.branchCode = branchCode;
        },
        search() {
            if (!this.$refs.frmReport.validate()) return;
            listJobImage(this.branchCode, this.jobNo).then(rs => {
                this.items = rs;
            });
        },
        createReport() {
            if (!this.$refs.frmReport.validate()) return;
            exportJobImage(this.branchCode, this.jobNo);
        }
    }
}
</script>